// extracted by mini-css-extract-plugin
module.exports = {"inner":"EditorFooter_inner__LiNzP","errorLogs":"EditorFooter_errorLogs__36KIT"};